// Remove initializing and loading states as soon as possible to show images
document.addEventListener('DOMContentLoaded', function () {
  document.body.removeAttribute('data-initializing');
  document.body.classList.remove('page-loading');
});

// Also remove on page show (for back/forward cache)
window.addEventListener('pageshow', function (_event) {
  document.body.removeAttribute('data-initializing');
  document.body.classList.remove('page-loading');
});

// Enhanced lazy loading with intersection observer
if ('loading' in HTMLImageElement.prototype) {
  // Native lazy loading supported
  const images = document.querySelectorAll('img[loading="lazy"]');
  images.forEach((img) => {
    img.addEventListener('load', function () {
      this.classList.add('loaded');
    });
  });
} else {
  // Fallback for browsers without native lazy loading
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');

  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('loaded');
            imageObserver.unobserve(img);
          }
        });
      },
      {
        rootMargin: '50px 0px',
        threshold: 0.01,
      }
    );

    lazyImages.forEach((img) => {
      img.dataset.src = img.src;
      img.src =
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
      imageObserver.observe(img);
    });
  }
}

// Preload critical above-the-fold images
window.addEventListener('DOMContentLoaded', () => {
  const criticalImages = document.querySelectorAll('img[data-critical="true"]');
  criticalImages.forEach((img) => {
    if (img.dataset.src) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = img.dataset.src;
      document.head.appendChild(link);
    }
  });
});

// Modern image format detection
function supportsWebP() {
  const elem = document.createElement('canvas');
  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  return false;
}

function supportsAVIF() {
  const avif = new Image();
  avif.src =
    'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
  return avif.complete && avif.width > 0 && avif.height > 0;
}

// Add support classes to HTML element
if (supportsWebP()) {
  document.documentElement.classList.add('webp');
}
if (supportsAVIF()) {
  document.documentElement.classList.add('avif');
}
